import React from "react"
import { useTranslation } from "react-i18next"

import type { Meter } from "@/models/meter"
import { ReadonlyField } from "@/nzds/forms/readonly-field/readonly-field"
import { getDisplayValue } from "@/utils/value"

import { MeterStatusChip } from "./meter-status-chip"

interface MeterImmutableReadonlyFieldsProps {
  meter: Meter
}

export const MeterImmutableReadonlyFields: React.FC<
  MeterImmutableReadonlyFieldsProps
> = ({ meter }) => {
  const { t } = useTranslation("common")

  return (
    <>
      <ReadonlyField
        label={t("fields.sourceType.title")}
        value={getDisplayValue(meter.meterSourceType?.name)}
      />
      <ReadonlyField
        label={t("editMeter.statusLabel")}
        value={<MeterStatusChip meterStatus={meter.meterStatus} />}
      />
      <ReadonlyField
        label={t("editMeter.emissionFactorLabel")}
        value={getDisplayValue(meter.emissionFactorDisplay)}
      />
      <ReadonlyField
        label={t("editMeter.onSiteGenerationLabel")}
        value={
          meter.isOnSiteGeneration ? t("editMeter.yes") : t("editMeter.no")
        }
      />
    </>
  )
}
